module.exports = __webpack_public_path__ + "static/media/checkbox2.5d0c19e9.svg";